// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".gf-user-avatar-cropper{position:absolute;bottom:-50px;left:50%;transform:translateX(-50%);display:flex;justify-content:center}@media screen and (min-width:576px){.gf-user-avatar-cropper{top:40px;left:40px;transform:none;bottom:auto}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
